import log from './log';
import vScene from './v-scene';

export default function registerDirectives(app) {
  app.directive('log', log);
  app.directive('scene', vScene);
}
